export default __webpack_public_path__ + "6411a70fcd1db55fddb1d1c416949a4e.png";